
export const OrderPriorityConstant: Record<number, { text: string; color: string }> = {
  1: { text: 'Critical', color: 'badge-danger' },
  2: { text: 'High', color: 'badge-orange' },
  3: { text: 'Medium', color: 'badge-warning' },
  4: { text: 'Low', color: 'badge-success' },
};
